<template>
  <span>
    <v-container
      fluid
      class="pa-0"
      v-if="!$vuetify.breakpoint.mdAndUp && !!!isdialog"
    >
      <v-layout row wrap justify-space-between>
        <v-flex sm9 class="d-flex justify-start">
          <v-btn text icon color="red">
            <v-icon @click="returnFunction">mdi-arrow-left</v-icon>
          </v-btn>
        </v-flex>
        <v-flex sm3 class="d-flex justify-end">
          <v-btn text icon color="green">
            <v-icon @click="returnFunction">mdi-share</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-text
      class="pa-0"
      :style="{
        height: $vuetify.breakpoint.smAndDown ? '83vh' : '87vh',
        'overflow-y': !!!isdialog ? 'scroll' : ''
      }"
    >
      <div
        class="d-flex flex-wrap"
        :class="{ 'mt-12': $vuetify.breakpoint.smAndDown && !!!isdialog }"
        id="flexInfo"
      >
        <template
          class="py-0"
          style="overflow-x: hidden; max-height: 100%; width: 100vw"
        >
          <v-app-bar
            :class="{ 'mt-8': $vuetify.breakpoint.smAndDown }"
            v-if="!!!isdialog"
            dense
            absolute
            color="white"
          >
            <v-tabs
              v-model="tab"
              :centered="$vuetify.breakpoint.smAndDown"
              grow
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
              align-with-title
              background-color="transparent"
            >
              <v-tab href="#tabPuesto">Puesto</v-tab>
              <v-tab href="#tabEmpresa">De la Empresa</v-tab>
            </v-tabs>
          </v-app-bar>
          <v-flex class="px-0">
            <v-tabs-items
              v-model="tab"
              :class="{ 'mt-12': $vuetify.breakpoint.mdAndUp && !!!isdialog }"
            >
              <v-tab-item id="tabPuesto">
                <v-flex class="px-0" style="font-size: small">
                  <v-img
                    :src="dataEmpresa.urlBanner"
                    v-if="$vuetify.breakpoint.mdAndUp && dataEmpresa.urlBanner"
                    max-height="25vh"
                  ></v-img>
                  <v-container>
                    <v-row v-if="esReciente(dataEmpresa.fechaPublicacion)">
                      <v-col
                        cols="12"
                        class="mx-auto d-flex justify-center align-center"
                        :class="{
                          'flex-row': $vuetify.breakpoint.mdAndUp,
                          'flex-column': $vuetify.breakpoint.smAndDown
                        }"
                      >
                        <v-chip
                          color="green"
                          text-color="white"
                          style="max-width: 80px"
                          >Reciente</v-chip
                        >
                        <p class="subtitle-1 font-weight-light mx-2 my-auto">
                          Adelántate y Postula antes que los demás
                        </p>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="esReciente(dataEmpresa.fechaPublicacion)"
                      class="my-2"
                    ></v-divider>
                    <!-- Aquí iría el código anterior -->
                    <v-container fluid>
                      <v-layout>
                        <v-row>
                          <v-col cols="12" xs="12">
                            <div
                              class="d-flex"
                              :class="
                                $vuetify.breakpoint.mdAndDown
                                  ? 'flex-column align-center'
                                  : 'flex-row justify-space-around align-center'
                              "
                            >
                              <div
                                id="logoEmpresa"
                                class="mx-4 d-flex flex-column"
                              >
                                <v-avatar size="160" max-height="100%">
                                  <img :src="dataEmpresa.idEmpresa.logo" />
                                </v-avatar>
                                <template v-if="!!!isdialog">
                                  <v-btn
                                    dark
                                    class="mx-1 my-2 native"
                                    :elevation="6"
                                    :outlined="!jobIsFavorite"
                                    :loading="isFavoriteLoading"
                                    color="bolsa-green"
                                    @click="setFavoriteJob"
                                    >{{
                                      jobIsFavorite ? 'Guardado' : 'Guardar'
                                    }}</v-btn
                                  >
                                  <v-btn
                                    class="mx-1 my-2 native"
                                    :elevation="8"
                                    :disabled="isExpired"
                                    :dark="!isExpired"
                                    :outlined="!isApplying"
                                    color="primary"
                                    @click="setApplyJob"
                                    >{{
                                      isApplying ? 'Postulando' : 'Postular'
                                    }}</v-btn
                                  >
                                </template>
                              </div>
                              <div
                                id="TituloTrabajo"
                                class="
                                  flex-column
                                  mx-4
                                  flex-grow-0 flex-shrink-0
                                "
                              >
                                <div
                                  id="Titulo"
                                  class="
                                    font-weight-bold
                                    text-h5
                                    flex-column
                                    mt-sm-4 mt-0
                                  "
                                >
                                  <div>{{ dataEmpresa.nombrePuesto }}</div>
                                  <div
                                    class="text-subtitle-1 font-weight-light"
                                  >
                                    en {{ dataEmpresa.idEmpresa.nombreEmpresa }}
                                  </div>
                                </div>
                                <div
                                  id="Ubicacion"
                                  class="my-2 text--secondary"
                                >
                                  <v-icon left color="bolsa-primary"
                                    >mdi-map-marker-outline</v-icon
                                  >
                                  {{ getUbicacionText }}
                                </div>

                                <div
                                  id="FechaPublicacion"
                                  class="
                                    d-flex
                                    align-center
                                    text--secondary text-caption
                                    my-2
                                  "
                                >
                                  <v-icon left color="bolsa-primary"
                                    >mdi-calendar-start</v-icon
                                  >Publicado:
                                  {{
                                    new Date(
                                      dataEmpresa.fechaPublicacion
                                    ).toLocaleDateString('es-ES', dateOptions)
                                  }}
                                </div>

                                <div
                                  id="FechaFinalizacion"
                                  class="
                                    d-flex
                                    align-center
                                    text--secondary text-caption
                                    my-2
                                  "
                                >
                                  <v-icon left color="bolsa-primary"
                                    >mdi-calendar-clock</v-icon
                                  >Requerido hasta:
                                  {{
                                    new Date(
                                      dataEmpresa.fechaVencimiento
                                    ).toLocaleDateString('es-ES', dateOptions)
                                  }}
                                </div>
                                <div id="DiasRestantes" class="my-4">
                                  <v-btn
                                    class="ma-2"
                                    outlined
                                    :color="daysLeftColor"
                                    rounded
                                    small
                                    depressed
                                    plain
                                    :ripple="false"
                                    >{{ getDaysLeft }}</v-btn
                                  >
                                  <v-btn
                                    class="ma-2"
                                    outlined
                                    color="bolsa-primary"
                                    rounded
                                    small
                                    depressed
                                    plain
                                    :ripple="false"
                                  >
                                    Horario {{ dataEmpresa.horario.tipo }}
                                  </v-btn>
                                </div>
                              </div>
                              <div
                                id="InfoPropuesta"
                                class="
                                  flex-column
                                  ml-4
                                  flex-shrink-1 flex-grow-0
                                "
                              >
                                <v-card outlined>
                                  <v-layout class="d-flex flex-column ma-4">
                                    <div class="d-flex ma-2">
                                      <v-icon left color="bolsa-primary"
                                        >mdi-account-cash-outline</v-icon
                                      >
                                      <div class="d-flex flex-column">
                                        <div
                                          class="text-body-2 font-weight-bold"
                                        >
                                          Salario Ofrecido
                                        </div>
                                        <div
                                          class="text-body-2 text--secondary"
                                        >
                                          {{ getSalario(dataEmpresa.salario) }}
                                        </div>
                                      </div>
                                    </div>

                                    <div class="d-flex ma-2">
                                      <v-icon left color="bolsa-primary"
                                        >mdi-account-check-outline</v-icon
                                      >
                                      <div class="d-flex flex-column">
                                        <div
                                          class="text-body-2 font-weight-bold"
                                        >
                                          # de Vacantes
                                        </div>
                                        <div
                                          class="text-body-2 text--secondary"
                                        >
                                          {{ dataEmpresa.cantidadVacantes }}
                                        </div>
                                      </div>
                                    </div>

                                    <div class="d-flex ma-2">
                                      <v-icon left color="bolsa-primary"
                                        >mdi-briefcase-clock-outline</v-icon
                                      >
                                      <div class="d-flex flex-column">
                                        <div
                                          class="text-body-2 font-weight-bold"
                                        >
                                          Horas Semanales
                                        </div>
                                        <div
                                          class="text-body-2 text--secondary"
                                        >
                                          {{
                                            dataEmpresa.horario.horasSemanales
                                          }}
                                          horas
                                        </div>
                                      </div>
                                    </div>

                                    <div class="d-flex ma-2">
                                      <v-icon left color="bolsa-primary"
                                        >mdi-puzzle-star-outline</v-icon
                                      >
                                      <div class="d-flex flex-column">
                                        <div
                                          class="text-body-2 font-weight-bold"
                                        >
                                          Industria
                                        </div>
                                        <div
                                          class="text-body-2 text--secondary"
                                        >
                                          {{
                                            dataEmpresa.idEmpresa
                                              .sectorIndustrial
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-layout>
                                </v-card>
                              </div>
                            </div>
                            <v-divider class="ma-6"></v-divider>
                            <div id="DescripcionTrabajo">
                              <div
                                id="TituloDescripcionTrabajo"
                                class="font-weight-medium text-h6"
                              >
                                Descripción General del Puesto
                              </div>
                              <div
                                id="DetalleDescripcionTrabajo"
                                class="
                                  text--secondary text-h6
                                  font-weight-light
                                  my-2
                                "
                              >
                                {{ dataEmpresa.descripcionTrabajo }}
                              </div>
                            </div>
                            <div id="FuncionesTrabajo" class="mt-6">
                              <div
                                id="TituloFuncionesTrabajo"
                                class="font-weight-medium text-h6"
                              >
                                Tus Funciones Principales serán...
                              </div>
                              <div id="DetalleFuncionesTrabajo" class="pt-2">
                                <span v-if="dataEmpresa.funciones.length">
                                  <p
                                    v-for="(
                                      item, index
                                    ) in dataEmpresa.funciones"
                                    :key="index"
                                    class="my-2 text-h6 font-weight-light"
                                  >
                                    <v-icon left color="bolsa-primary"
                                      >mdi-account-hard-hat</v-icon
                                    >
                                    {{ item }}
                                  </p>
                                </span>
                                <span v-else>
                                  <p class="my-2 text-h6 font-weight-light">
                                    No especificado
                                  </p>
                                </span>
                              </div>
                            </div>
                            <div id="SkillsTrabajo" class="mt-6">
                              <div
                                id="TituloSkillsTrabajo"
                                class="font-weight-medium text-h6"
                              >
                                Requerimos tu Experiencia y Habilidades en...
                              </div>
                              <div id="DetalleSkillsTrabajo" class="pt-2">
                                <span v-if="dataEmpresa.experiencia.length">
                                  <p
                                    v-for="(
                                      item, index
                                    ) in dataEmpresa.experiencia"
                                    :key="index"
                                    class="my-2 text-h6 font-weight-light"
                                  >
                                    <v-icon left color="bolsa-primary"
                                      >mdi-briefcase-search-outline</v-icon
                                    >
                                    {{ item.detalle }} ·
                                    <span
                                      class="font-weight-bold text-lowercase"
                                    >
                                      {{
                                        item.tiempo
                                          ? item.tiempo + ' ' + item.unidad
                                          : ''
                                      }}
                                    </span>
                                  </p>
                                </span>
                                <span v-else>
                                  <p class="my-2 text-h6 my-2">
                                    <v-icon left color="bolsa-primary"
                                      >mdi-briefcase-search-outline</v-icon
                                    >Ninguna experiencia requerida
                                  </p>
                                </span>

                                <span v-if="dataEmpresa.conocimientos.length">
                                  <p
                                    v-for="(
                                      item, index
                                    ) in dataEmpresa.conocimientos"
                                    :key="index"
                                    class="my-2 text-h6 font-weight-light"
                                  >
                                    <v-icon left color="bolsa-primary"
                                      >mdi-head-snowflake-outline</v-icon
                                    >
                                    {{ item.descripcion }} ·
                                    <span class="font-weight-bold">
                                      {{ item.tipo }}
                                    </span>
                                  </p>
                                </span>
                                <span v-else>
                                  <p class="my-2 text-h6 font-weight-light">
                                    <v-icon left color="bolsa-primary"
                                      >mdi-head-snowflake-outline</v-icon
                                    >
                                    Ninguna habilidad requerida
                                  </p>
                                </span>

                                <span v-if="dataEmpresa.idiomas.length">
                                  <p
                                    v-for="(item, index) in dataEmpresa.idiomas"
                                    :key="index"
                                    class="my-2 text-h6 font-weight-light"
                                  >
                                    <v-icon
                                      v-if="dataEmpresa.idiomas.length"
                                      left
                                      color="bolsa-primary"
                                      >mdi-translate</v-icon
                                    >
                                    {{ item.idioma }} ·
                                    <span
                                      class="font-weight-bold text-lowercase"
                                    >
                                      {{ item.nivel }}
                                    </span>
                                  </p>
                                </span>
                                <span v-else>
                                  <p class="my-2 text-h6">
                                    <v-icon
                                      v-if="dataEmpresa.idiomas.length"
                                      left
                                      color="bolsa-primary"
                                      >mdi-translate</v-icon
                                    >Ningún idioma requerido
                                  </p>
                                </span>
                              </div>
                            </div>
                            <div id="SkillsTrabajo" class="mt-6">
                              <div
                                id="TituloSkillsTrabajo"
                                class="font-weight-medium text-h6"
                              >
                                Grado Académico + Mérito
                              </div>
                              <div id="DetalleSkillsTrabajo" class="pt-2">
                                <p
                                  class="
                                    text-capitalize
                                    my-2
                                    text-h6
                                    font-weight-light
                                  "
                                >
                                  <v-icon left color="bolsa-primary"
                                    >mdi-school-outline</v-icon
                                  >Grado Académico ·
                                  <span class="font-weight-bold">
                                    {{ dataEmpresa.gradoAcademico.join(', ') }}
                                  </span>
                                </p>
                                <p
                                  class="
                                    text-capitalize
                                    my-2
                                    text-h6
                                    font-weight-light
                                  "
                                >
                                  <v-icon left color="bolsa-primary"
                                    >mdi-school-outline</v-icon
                                  >Mérito Académico ·
                                  <span class="font-weight-bold text-lowercase">
                                    {{
                                      dataEmpresa.ordenMerito !== 'CUALQUIERA'
                                        ? `${dataEmpresa.ordenMerito} SUPERIOR`
                                        : dataEmpresa.ordenMerito
                                    }}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </v-container>
                  </v-container>
                </v-flex>
              </v-tab-item>
              <v-tab-item value="tabEmpresa">
                <div class="d-flex px-0 py-4 flex-column">
                  <div
                    class="d-flex"
                    :class="{
                      'flex-row': $vuetify.breakpoint.mdAndUp,
                      'flex-column': $vuetify.breakpoint.smAndDown
                    }"
                  >
                    <div class="d-flex justify-center flex-grow-0">
                      <v-img
                        class="ma-4"
                        :src="dataEmpresa.idEmpresa.logo"
                        contain
                        max-height="35vh"
                        max-width="25vw"
                      ></v-img>
                    </div>
                    <div class="d-flex flex-column flex-grow-1 mx-4">
                      <div class="d-flex flex-row justify-center mb-4">
                        <p class="display-1">
                          {{ dataEmpresa.idEmpresa.nombreEmpresa }}
                        </p>
                      </div>
                      <p class="mb-4">
                        <span class="font-weight-bold">
                          <v-icon class="mr-2">mdi-map-marker-radius</v-icon
                          >Dirección Principal:
                        </span>
                        {{ dataEmpresa.idEmpresa.direccion }}
                      </p>
                      <p class="mb-4">
                        <span class="font-weight-bold">
                          <v-icon class="mr-2">mdi-update</v-icon>Fecha de
                          Ingreso a la Plataforma:
                        </span>
                        {{
                          new Date(
                            dataEmpresa.idEmpresa.fechaCreacion
                          ).toLocaleDateString('es-ES', dateOptions)
                        }}
                      </p>
                      <p class="mb-4">
                        <span class="font-weight-bold">
                          <v-icon class="mr-2">mdi-domain</v-icon>RUC:
                        </span>
                        {{ dataEmpresa.idEmpresa.ruc }}
                      </p>
                      <p class="mb-4">
                        <span class="font-weight-bold">
                          <v-icon class="mr-2">mdi-factory</v-icon>Sector
                          Industrial:
                        </span>
                        {{ dataEmpresa.idEmpresa.sectorIndustrial }}
                      </p>
                      <p class="mb-4">
                        <span class="font-weight-bold">
                          <v-icon class="mr-2">mdi-link-variant</v-icon>Sitio
                          Web:
                        </span>
                        <a
                          target="_blank"
                          :href="dataEmpresa.idEmpresa.sitioWeb"
                          >{{ dataEmpresa.idEmpresa.sitioWeb }}</a
                        >
                      </p>
                    </div>
                  </div>
                  <p></p>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </template>
      </div>
    </v-card-text>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateDiff from 'date-diff'

export default {
  components: {
    DateDiff
  },
  props: ['dataEmpresa', 'isdialog'],
  data: function () {
    return {
      DateDiff: DateDiff,
      page: 1,
      jobIsFavorite: false,
      isApplying: false,
      snackbarSaved: false,
      daysLeftColor: '',
      isExpired: false,
      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },
      tab: 'tabPuesto',
      info: this.dataEmpresa | this.$route.query,
      isFavoriteLoading: false,
      isApplyLoading: false
    }
  },
  methods: {
    ...mapActions('user', ['setFavorite', 'applyJob']),

    returnFunction: function () {
      this.$emit('btnRetorno', {})
    },

    setFavoriteJob: async function () {
      this.isFavoriteLoading = true
      await this.setFavorite({
        idTrabajo: this.dataEmpresa._id,
        isFavorite: !this.jobIsFavorite
      })
      this.isFavoriteLoading = false
      if (!this.getError.error) this.jobIsFavorite = !this.jobIsFavorite
      this.$emit('saveJob', this.jobIsFavorite, this.getError)
    },

    setApplyJob: async function () {
      if (!this.isExpired) {
        this.isApplyLoading = true
        await this.applyJob(this.dataEmpresa._id)
        this.isApplyLoading = false
        if (!this.getError.error) this.isApplying = !this.isApplying
        this.$emit('applyJob', this.isApplying, this.getError)
      } else {
        this.$emit('applyJob', {
          error: true,
          errorMessage: 'Este trabajo ya expiró, no puedes postular.'
        })
      }
    },

    esReciente: (date) => {
      return Date.now() - new Date(date).getTime() < 1000 * 60 * 60 * 4
    },

    getSalario: function (salarioObject) {
      const salarioMoneda =
        salarioObject.moneda === 'SOL'
          ? 'S/'
          : salarioObject.moneda === 'DOLAR'
          ? '$'
          : salarioObject.moneda === 'EURO'
          ? '€'
          : ''
      return salarioObject.tipo === 'RANGO'
        ? `Entre ${salarioMoneda} ${salarioObject.valor.minimo} y ${salarioMoneda} ${salarioObject.valor.maximo}`
        : salarioObject.tipo === 'FIJO'
        ? `${salarioMoneda} ${salarioObject.valor}`
        : salarioObject.tipo === 'NO DEFINIDO'
        ? 'Por definir'
        : '-'
    }
  },
  computed: {
    ...mapGetters('user', ['getError']),
    getDaysLeft() {
      const daysLeft = Math.floor(
        new DateDiff(
          new Date(this.dataEmpresa.fechaVencimiento),
          Date.now()
        ).days()
      )
      this.isExpired = daysLeft < 0
      this.daysLeftColor =
        daysLeft < 7
          ? 'red'
          : daysLeft < 15
          ? '#FFD600'
          : daysLeft < 30
          ? 'green'
          : 'green'
      if (daysLeft < 0)
        return `(Expiró hace ${daysLeft * -1} ${
          daysLeft == -1 ? 'día' : 'días'
        })`
      return `${daysLeft} ${daysLeft == 1 ? 'día restante´' : 'días restantes'}`
    },

    getUbicacionText() {
      let departamento = this.dataEmpresa.ubigeoNombre.departamento
        ? this.dataEmpresa.ubigeoNombre.departamento
            .toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase()) + ', '
        : ''

      let provincia = this.dataEmpresa.ubigeoNombre.provincia
        ? this.dataEmpresa.ubigeoNombre.provincia
            .toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase()) + ', '
        : ''

      let distrito = this.dataEmpresa.ubigeoNombre.distrito
        ? this.dataEmpresa.ubigeoNombre.distrito
            .toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase())
        : ''
      return departamento + provincia + distrito
    }
  },
  mounted: function () {
    this.jobIsFavorite = this.dataEmpresa.favorito
    this.isApplying = this.dataEmpresa.postulado
  }
}
</script>
<style scoped>
pre {
  white-space: pre-wrap;
}

#flexInfo {
  overflow: hidden;
  background: #f9f9f9;
  color: rgba(0, 0, 0, 0.87);
}

#firstInfo p {
  text-align: left;
  word-break: break-all;
  hyphens: auto;
}

p {
  margin-bottom: 0;
}

.v-toolbar__content {
  display: none;
}

.native:focus::before {
  opacity: 0 !important;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(245, 245, 245, 0.15);
}

::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(245, 245, 245, 0.308);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: rgba(85, 85, 85, 0.5);
}
</style>
